export const sumRefund = (product) => {
    return (+product.producer_refund_amount || 0) + (+product.organizer_refund_amount || 0)
}